import {
  ProjectSubmission, ProjectCloseoutStorePayload,
} from '../models';
import { SubmissionSource, RequestStatus } from '../models/enums';
import { ProjectCloseout } from '../models/projectCloseout.model';

const buildCreatePayload = (payload: ProjectCloseoutStorePayload): ProjectCloseout => {
  const project: ProjectSubmission = {
    name: payload.projectName,
    number: payload.projectNumber,
    city: payload.companyCity,
    country: payload.contactCountry,
    stateProvince: payload.contactState,
    estimatedCompletionDate: payload.estimatedCompletionDate,
    yearCompleted: payload.projectCompletionDate.getFullYear(),
    source: SubmissionSource.ProjectCloseout,
  };


  return {
    project,
    finalContractAmount: Number.parseFloat(payload.finalContractAmount),
    dateCompleted: payload.projectCompletionDate,
    companyName: payload.yourCompanyName,
    closeoutInformationSubmittedBy: payload.closeoutInformation,
    submitterEmail: payload.submitterEmail,
    status: RequestStatus.Pending,
  };
};


export default {
  buildCreatePayload,
};